export const selectGrantFit = ({ grantfit }) => grantfit
